// Shared, persisted user settings (render/UI-side only — never touches the sim).
// Consumed by the audio engine, the renderer (screen shake) and the menus.

export interface Settings {
  shake: boolean; // screen shake on big explosions
  sfxVolume: number; // 0..1 master SFX volume
  muted: boolean; // hard mute
  unitArt: "sprite" | "vector"; // pre-rendered 3D atlas vs procedural vector art
}

const KEY = "torrent.settings.v1";

// Default to pre-rendered 3D; the renderer auto-falls back to vector art if the
// sprite atlas is missing or fails to load, so this is safe even without sprites.
const DEFAULTS: Settings = { shake: true, sfxVolume: 0.6, muted: false, unitArt: "sprite" };

function load(): Settings {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) return { ...DEFAULTS, ...JSON.parse(raw) };
  } catch {
    /* ignore */
  }
  return { ...DEFAULTS };
}

export const settings: Settings = load();

export function saveSettings(): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(settings));
  } catch {
    /* ignore */
  }
}
